import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  GeneralError1q7afgn844yvi as GeneralError,
  OperationComplete35pb9wj3i5rr0 as OperationComplete,
  ConnectionReEstablishedspo1kq7uvs59 as ConnectionReEstablished,
  NetworkErrorotwtrw4n54or as NetworkError,
  OperationError2sah6hjojh8as as OperationError,
  OperationResponseq42n5mfh87yx as OperationResponse,
  Dispose3n637sa8gbmf1 as Dispose,
  StopOperation41dlmx7s82zc as StopOperation,
  RestartConnection3ucejekzrnll6 as RestartConnection,
  StartOperation372o3p2p9vxt5 as StartOperation,
  Command2ao3eytvqoynn as Command,
  RestartConnection_instancezia28sn269s2 as RestartConnection_instance,
  Event2qcujbxqrid4f as Event,
  Dispose_instance2mubuj640kzg1 as Dispose_instance,
} from './internal/WsMessage.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  SubscriptionOperationException3t8cqqpx8bt9j as SubscriptionOperationException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Key_getInstance4887rkxhu93r as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  isDeferred3jq83655znees as isDeferred,
  DeferredJsonMerger16i62uujz1qml as DeferredJsonMerger,
} from '../../internal/DeferredJsonMerger.mjs';
import { jsonReader2agwreccj3lmk as jsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { toApolloResponse9u5mcqg84l2p as toApolloResponse } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { CoroutineStart_UNDISPATCHED_getInstance3vhik5zct4e74 as CoroutineStart_UNDISPATCHED_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { get_ONEazvfdh9ju3d4 as get_ONE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/boxedLong/boxedLong.mjs';
import { add2suhfggl4zvkk as add } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { DefaultWebSocketEngine2qlkcxmcddkl7 as DefaultWebSocketEngine } from './JsWebSocketEngine.mjs';
import { Factory2jyzsj2j7cj0z as Factory } from './SubscriptionWsProtocol.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/FlowCollector.mjs';
import {
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { delay3147v9lzv1xxn as delay } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { Channel3r72atmcithql as Channel } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import { BufferOverflow_SUSPEND_getInstance3j24qbb4wnzlq as BufferOverflow_SUSPEND_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/BufferOverflow.mjs';
import { MutableSharedFlow3g4w4npzofx4w as MutableSharedFlow } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/SharedFlow.mjs';
import {
  asSharedFlow2buz3fbrowsyg as asSharedFlow,
  onSubscription3iwvbdmbwg7iq as onSubscription,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Share.mjs';
import { Dispatchers_getInstance2p2r3ndn98nn as Dispatchers_getInstance } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Dispatchers.mjs';
import { transformWhile1eyv77fe96rjt as transformWhile } from '../../internal/flows.mjs';
import { onCompletion2zzj1m13j2omp as onCompletion } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Emitters.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WebSocketNetworkTransport$Builder$serverUrl$slambdaClass;
function WebSocketNetworkTransport$Builder$serverUrl$slambda() {
  if (WebSocketNetworkTransport$Builder$serverUrl$slambdaClass === VOID) {
    class $ {
      constructor($serverUrl) {
        this.w6b_1 = $serverUrl;
      }
      *v3r($completion) {
        return this.w6b_1;
      }
      kd($completion) {
        return this.v3r($completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    WebSocketNetworkTransport$Builder$serverUrl$slambdaClass = $;
  }
  return WebSocketNetworkTransport$Builder$serverUrl$slambdaClass;
}
function WebSocketNetworkTransport$Builder$serverUrl$slambda_0($serverUrl) {
  var i = new (WebSocketNetworkTransport$Builder$serverUrl$slambda())($serverUrl);
  var l = ($completion) => i.v3r($completion);
  l.$arity = 0;
  return l;
}
var WebSocketNetworkTransport$execute$o$collect$slambdaClass;
function WebSocketNetworkTransport$execute$o$collect$slambda() {
  if (WebSocketNetworkTransport$execute$o$collect$slambdaClass === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $request) {
        this.x6b_1 = $$this$unsafeFlow;
        this.y6b_1 = $request;
      }
      *o1h(value, $completion) {
        var tmp0 = this.x6b_1;
        $l$block: {
          if (value.x31() === this.y6b_1.j43_1.toString() || value.x31() == null) {
            yield* tmp0.h1d(value, $completion);
            break $l$block;
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o1h(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$o$collect$slambdaClass = $;
  }
  return WebSocketNetworkTransport$execute$o$collect$slambdaClass;
}
function WebSocketNetworkTransport$execute$o$collect$slambda_0($$this$unsafeFlow, $request) {
  var i = new (WebSocketNetworkTransport$execute$o$collect$slambda())($$this$unsafeFlow, $request);
  var l = (value, $completion) => i.o1h(value, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransport$execute$o$collect$slambdaClass_0;
function WebSocketNetworkTransport$execute$o$collect$slambda_1() {
  if (WebSocketNetworkTransport$execute$o$collect$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $request, $deferredJsonMerger, this$0) {
        this.z6b_1 = $$this$unsafeFlow;
        this.a6c_1 = $request;
        this.b6c_1 = $deferredJsonMerger;
        this.c6c_1 = this$0;
      }
      *o1h(value, $completion) {
        var $this$transform = this.z6b_1;
        var tmp;
        if (value instanceof OperationResponse()) {
          var responsePayload = value.i6c_1;
          var requestCustomScalarAdapters = ensureNotNull(this.a6c_1.k43_1.r46(Key_getInstance()));
          var tmp_0;
          if (isDeferred(responsePayload)) {
            tmp_0 = to(this.b6c_1.q67(responsePayload), this.b6c_1.m67_1);
          } else {
            tmp_0 = to(responsePayload, null);
          }
          var _destruct__k2r9zo = tmp_0;
          var payload = _destruct__k2r9zo.we();
          var mergedFragmentIds = _destruct__k2r9zo.xe();
          var apolloResponse = toApolloResponse(jsonReader(payload), this.a6c_1.i43_1, this.a6c_1.j43_1, requestCustomScalarAdapters, mergedFragmentIds);
          if (!this.b6c_1.n67_1) {
            this.b6c_1.p3o();
          }
          tmp = apolloResponse;
        } else {
          if (value instanceof OperationError()) {
            tmp = errorResponse(this.c6c_1, this.a6c_1, SubscriptionOperationException().c4e(this.a6c_1.i43_1.operationName(), value.g6c_1));
          } else {
            if (value instanceof NetworkError()) {
              tmp = errorResponse(this.c6c_1, this.a6c_1, ApolloNetworkException().t47('Network error while executing ' + this.a6c_1.i43_1.operationName(), value.d6c_1));
            } else {
              var tmp_1;
              if (value instanceof ConnectionReEstablished()) {
                tmp_1 = true;
              } else {
                var tmp_2;
                if (value instanceof OperationComplete()) {
                  tmp_2 = true;
                } else {
                  tmp_2 = value instanceof GeneralError();
                }
                tmp_1 = tmp_2;
              }
              if (tmp_1) {
                // Inline function 'kotlin.error' call
                var message = 'Unexpected event ' + toString(value);
                throw IllegalStateException().o(toString(message));
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
        var tmp$ret$1 = tmp;
        yield* $this$transform.h1d(tmp$ret$1, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o1h(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$o$collect$slambdaClass_0 = $;
  }
  return WebSocketNetworkTransport$execute$o$collect$slambdaClass_0;
}
function WebSocketNetworkTransport$execute$o$collect$slambda_2($$this$unsafeFlow, $request, $deferredJsonMerger, this$0) {
  var i = new (WebSocketNetworkTransport$execute$o$collect$slambda_1())($$this$unsafeFlow, $request, $deferredJsonMerger, this$0);
  var l = (value, $completion) => i.o1h(value, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransport$execute$o$collect$slambdaClass_1;
function WebSocketNetworkTransport$execute$o$collect$slambda_3() {
  if (WebSocketNetworkTransport$execute$o$collect$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$unsafeFlow, $deferredJsonMerger) {
        this.j6c_1 = $$this$unsafeFlow;
        this.k6c_1 = $deferredJsonMerger;
      }
      *o1h(value, $completion) {
        var tmp0 = this.j6c_1;
        $l$block: {
          if (!this.k6c_1.o67_1) {
            yield* tmp0.h1d(value, $completion);
            break $l$block;
          }
        }
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.o1h(p1, $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$o$collect$slambdaClass_1 = $;
  }
  return WebSocketNetworkTransport$execute$o$collect$slambdaClass_1;
}
function WebSocketNetworkTransport$execute$o$collect$slambda_4($$this$unsafeFlow, $deferredJsonMerger) {
  var i = new (WebSocketNetworkTransport$execute$o$collect$slambda_3())($$this$unsafeFlow, $deferredJsonMerger);
  var l = (value, $completion) => i.o1h(value, $completion);
  l.$arity = 1;
  return l;
}
function *supervise($this, scope, $completion) {
  var idleJob = {_v: null};
  var connectionJob = {_v: null};
  var protocol = {_v: null};
  var reopenAttemptCount = 0n;
  // Inline function 'kotlin.collections.mutableMapOf' call
  var activeMessages = LinkedHashMap().bc();
  $l$loop_1: while (true) {
    var message = yield* $this.r6c_1.w1a($completion);
    if (isInterface(message, Event())) {
      if (message instanceof NetworkError()) {
        supervise$closeProtocol(protocol, connectionJob, idleJob);
        var tmp0_safe_receiver = $this.q6c_1;
        if ((tmp0_safe_receiver == null ? null : (yield* tmp0_safe_receiver(message.d6c_1, reopenAttemptCount, $completion))) === true) {
          var _unary__edvuaz = reopenAttemptCount;
          reopenAttemptCount = add(_unary__edvuaz, get_ONE());
          yield* $this.r6c_1.s1a(RestartConnection_instance, $completion);
        } else {
          reopenAttemptCount = 0n;
          $this.s6c_1.r1e(message);
        }
      } else {
        if (message instanceof ConnectionReEstablished()) {
          reopenAttemptCount = 0n;
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = activeMessages.w4().p1();
          while (_iterator__ex2g4s.q1()) {
            var element = _iterator__ex2g4s.r1();
            $this.r6c_1.t1a(element);
          }
        } else {
          reopenAttemptCount = 0n;
          $this.s6c_1.r1e(message);
        }
      }
    } else {
      if (isInterface(message, Command())) {
        if (message instanceof Dispose()) {
          supervise$closeProtocol(protocol, connectionJob, idleJob);
          return Unit_instance;
        }
        if (protocol._v == null) {
          if (message instanceof StopOperation()) {
            activeMessages.y4(message.y6c_1.j43_1);
            continue $l$loop_1;
          }
          var tmp;
          try {
            var tmp_0 = yield* $this.l6c_1($completion);
            var tmp_1;
            var tmp0 = $this.m6c_1;
            var tmp$ret$3;
            $l$block_0: {
              // Inline function 'kotlin.collections.any' call
              var tmp_2;
              if (isInterface(tmp0, Collection())) {
                tmp_2 = tmp0.n1();
              } else {
                tmp_2 = false;
              }
              if (tmp_2) {
                tmp$ret$3 = false;
                break $l$block_0;
              }
              var _iterator__ex2g4s_0 = tmp0.p1();
              while (_iterator__ex2g4s_0.q1()) {
                var element_0 = _iterator__ex2g4s_0.r1();
                if (element_0.i49_1 === 'Sec-WebSocket-Protocol') {
                  tmp$ret$3 = true;
                  break $l$block_0;
                }
              }
              tmp$ret$3 = false;
            }
            if (tmp$ret$3) {
              tmp_1 = $this.m6c_1;
            } else {
              tmp_1 = plus($this.m6c_1, new (HttpHeader())('Sec-WebSocket-Protocol', $this.p6c_1.h1()));
            }
            tmp = yield* $this.n6c_1.z6c(tmp_0, tmp_1, $completion);
          } catch ($p) {
            var tmp_3;
            if ($p instanceof Exception()) {
              var e = $p;
              yield* $this.r6c_1.s1a(new (NetworkError())(e), $completion);
              continue $l$loop_1;
            } else {
              throw $p;
            }
          }
          var webSocketConnection = tmp;
          protocol._v = $this.p6c_1.x6a(webSocketConnection, $this.x6c_1, scope);
          try {
            yield* ensureNotNull(protocol._v).h6b($completion);
          } catch ($p) {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              protocol._v = null;
              yield* $this.r6c_1.s1a(new (NetworkError())(e_0), $completion);
              continue $l$loop_1;
            } else {
              throw $p;
            }
          }
          var tmp_4 = CoroutineStart_UNDISPATCHED_getInstance();
          connectionJob._v = launch(scope, VOID, tmp_4, WebSocketNetworkTransport$supervise$slambda_0(protocol));
        }
        if (message instanceof StartOperation()) {
          // Inline function 'kotlin.collections.set' call
          var key = message.a6d_1.j43_1;
          activeMessages.x4(key, message);
          ensureNotNull(protocol._v).o6b(message.a6d_1);
        } else {
          if (message instanceof StopOperation()) {
            activeMessages.y4(message.y6c_1.j43_1);
            ensureNotNull(protocol._v).p6b(message.y6c_1);
          } else {
            if (message instanceof RestartConnection()) {
              yield* $this.r6c_1.s1a(new (ConnectionReEstablished())(), $completion);
            }
          }
        }
        if (activeMessages.n1()) {
          idleJob._v = launch(scope, VOID, VOID, WebSocketNetworkTransport$supervise$slambda_2($this, protocol, connectionJob, idleJob));
        } else {
          var tmp2_safe_receiver = idleJob._v;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.dx();
          }
          idleJob._v = null;
        }
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  return Unit_instance;
}
function errorResponse($this, request, apolloException) {
  var tmp0_requestUuid = request.j43_1;
  var tmp1_operation = request.i43_1;
  return Builder().g44(tmp1_operation, tmp0_requestUuid).l44(apolloException).n44(true).p37();
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.a66_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.b66_1 = ArrayList().p2();
        this.c66_1 = null;
        this.d66_1 = null;
        this.e66_1 = null;
        this.f66_1 = null;
      }
      s64(serverUrl) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        tmp.a66_1 = WebSocketNetworkTransport$Builder$serverUrl$slambda_0(serverUrl);
        return this;
      }
      k66(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.a66_1 = serverUrl;
        return this;
      }
      g66(webSocketEngine) {
        // Inline function 'kotlin.apply' call
        this.c66_1 = webSocketEngine;
        return this;
      }
      h66(idleTimeoutMillis) {
        // Inline function 'kotlin.apply' call
        this.d66_1 = idleTimeoutMillis;
        return this;
      }
      i66(protocolFactory) {
        // Inline function 'kotlin.apply' call
        this.e66_1 = protocolFactory;
        return this;
      }
      j66(reopenWhen) {
        // Inline function 'kotlin.apply' call
        this.f66_1 = reopenWhen;
        return this;
      }
      p37() {
        var tmp0_elvis_lhs = this.a66_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.error' call
          var message = 'No serverUrl specified';
          throw IllegalStateException().o(toString(message));
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var tmp_0 = tmp;
        var tmp_1 = this.b66_1;
        var tmp1_elvis_lhs = this.c66_1;
        var tmp_2 = tmp1_elvis_lhs == null ? new (DefaultWebSocketEngine())() : tmp1_elvis_lhs;
        var tmp2_elvis_lhs = this.d66_1;
        var tmp_3 = tmp2_elvis_lhs == null ? 60000n : tmp2_elvis_lhs;
        var tmp3_elvis_lhs = this.e66_1;
        return new (WebSocketNetworkTransport())(tmp_0, tmp_1, tmp_2, tmp_3, tmp3_elvis_lhs == null ? new (Factory())() : tmp3_elvis_lhs, this.f66_1);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var sam$kotlinx_coroutines_flow_FlowCollector$0Class;
function sam$kotlinx_coroutines_flow_FlowCollector$0() {
  if (sam$kotlinx_coroutines_flow_FlowCollector$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.b6d_1 = function_0;
      }
      *h1d(value, $completion) {
        return yield* this.b6d_1(value, $completion);
      }
      i5() {
        return this.b6d_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, FlowCollector()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector(), FunctionAdapter()], [1]);
    sam$kotlinx_coroutines_flow_FlowCollector$0Class = $;
  }
  return sam$kotlinx_coroutines_flow_FlowCollector$0Class;
}
var WebSocketNetworkTransport$slambdaClass;
function WebSocketNetworkTransport$slambda() {
  if (WebSocketNetworkTransport$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.c6d_1 = this$0;
      }
      *r1f($this$launch, $completion) {
        yield* /*#__NOINLINE__*/supervise(this.c6d_1, $this$launch, $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$slambdaClass = $;
  }
  return WebSocketNetworkTransport$slambdaClass;
}
function WebSocketNetworkTransport$slambda_0(this$0) {
  var i = new (WebSocketNetworkTransport$slambda())(this$0);
  var l = ($this$launch, $completion) => i.r1f($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransport$listener$1Class;
function WebSocketNetworkTransport$listener$1() {
  if (WebSocketNetworkTransport$listener$1Class === VOID) {
    class $ {
      constructor(this$0) {
        this.d6d_1 = this$0;
      }
      n6b(id, payload) {
        this.d6d_1.r6c_1.t1a(new (OperationResponse())(id, payload));
      }
      m6b(id, payload) {
        this.d6d_1.r6c_1.t1a(new (OperationError())(id, payload));
      }
      k6b(id) {
        this.d6d_1.r6c_1.t1a(new (OperationComplete())(id));
      }
      l6b(payload) {
        this.d6d_1.r6c_1.t1a(new (GeneralError())(payload));
      }
      e6d(cause) {
        this.d6d_1.r6c_1.t1a(new (NetworkError())(cause));
      }
    }
    initMetadataForClass($);
    WebSocketNetworkTransport$listener$1Class = $;
  }
  return WebSocketNetworkTransport$listener$1Class;
}
function supervise$closeProtocol(protocol, connectionJob, idleJob) {
  var tmp0_safe_receiver = protocol._v;
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.l6();
  }
  protocol._v = null;
  var tmp1_safe_receiver = connectionJob._v;
  if (tmp1_safe_receiver == null)
    null;
  else {
    tmp1_safe_receiver.dx();
  }
  connectionJob._v = null;
  var tmp2_safe_receiver = idleJob._v;
  if (tmp2_safe_receiver == null)
    null;
  else {
    tmp2_safe_receiver.dx();
  }
  idleJob._v = null;
}
var WebSocketNetworkTransport$supervise$slambdaClass;
function WebSocketNetworkTransport$supervise$slambda() {
  if (WebSocketNetworkTransport$supervise$slambdaClass === VOID) {
    class $ {
      constructor($protocol) {
        this.f6d_1 = $protocol;
      }
      *r1f($this$launch, $completion) {
        yield* ensureNotNull(this.f6d_1._v).v6b($completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$supervise$slambdaClass = $;
  }
  return WebSocketNetworkTransport$supervise$slambdaClass;
}
function WebSocketNetworkTransport$supervise$slambda_0($protocol) {
  var i = new (WebSocketNetworkTransport$supervise$slambda())($protocol);
  var l = ($this$launch, $completion) => i.r1f($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransport$supervise$slambdaClass_0;
function WebSocketNetworkTransport$supervise$slambda_1() {
  if (WebSocketNetworkTransport$supervise$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $protocol, $connectionJob, $idleJob) {
        this.g6d_1 = this$0;
        this.h6d_1 = $protocol;
        this.i6d_1 = $connectionJob;
        this.j6d_1 = $idleJob;
      }
      *r1f($this$launch, $completion) {
        yield* delay(this.g6d_1.o6c_1, $completion);
        supervise$closeProtocol(this.h6d_1, this.i6d_1, this.j6d_1);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.r1f((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$supervise$slambdaClass_0 = $;
  }
  return WebSocketNetworkTransport$supervise$slambdaClass_0;
}
function WebSocketNetworkTransport$supervise$slambda_2(this$0, $protocol, $connectionJob, $idleJob) {
  var i = new (WebSocketNetworkTransport$supervise$slambda_1())(this$0, $protocol, $connectionJob, $idleJob);
  var l = ($this$launch, $completion) => i.r1f($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransport$execute$slambdaClass;
function WebSocketNetworkTransport$execute$slambda() {
  if (WebSocketNetworkTransport$execute$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $request) {
        this.k6d_1 = this$0;
        this.l6d_1 = $request;
      }
      *m6d($this$onSubscription, $completion) {
        yield* this.k6d_1.r6c_1.s1a(new (StartOperation())(this.l6d_1), $completion);
        return Unit_instance;
      }
      ld(p1, $completion) {
        return this.m6d((!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$slambdaClass = $;
  }
  return WebSocketNetworkTransport$execute$slambdaClass;
}
function WebSocketNetworkTransport$execute$slambda_0(this$0, $request) {
  var i = new (WebSocketNetworkTransport$execute$slambda())(this$0, $request);
  var l = ($this$onSubscription, $completion) => i.m6d($this$onSubscription, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransport$execute$$inlined$filter$1Class;
function WebSocketNetworkTransport$execute$$inlined$filter$1() {
  if (WebSocketNetworkTransport$execute$$inlined$filter$1Class === VOID) {
    class $ {
      constructor($this, $request) {
        this.n6d_1 = $this;
        this.o6d_1 = $request;
      }
      *g1d(collector, $completion) {
        var tmp = WebSocketNetworkTransport$execute$o$collect$slambda_0(collector, this.o6d_1);
        yield* this.n6d_1.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      p1c(collector, $completion) {
        return this.g1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$filter$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$filter$1Class;
}
var WebSocketNetworkTransport$execute$slambdaClass_0;
function WebSocketNetworkTransport$execute$slambda_1() {
  if (WebSocketNetworkTransport$execute$slambdaClass_0 === VOID) {
    class $ {
      constructor($request) {
        this.p6d_1 = $request;
      }
      *q6d($this$transformWhile, it, $completion) {
        var tmp;
        if (it instanceof OperationComplete()) {
          tmp = false;
        } else {
          if (it instanceof ConnectionReEstablished()) {
            tmp = false;
          } else {
            if (it instanceof NetworkError()) {
              yield* $this$transformWhile.h1d(it, $completion);
              tmp = false;
            } else {
              if (it instanceof GeneralError()) {
                println('Received general error while executing operation ' + this.p6d_1.i43_1.operationName() + ': ' + toString_0(it.r6d_1));
                tmp = true;
              } else {
                yield* $this$transformWhile.h1d(it, $completion);
                tmp = true;
              }
            }
          }
        }
        return tmp;
      }
      md(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        return this.q6d(tmp, (!(p2 == null) ? isInterface(p2, Event()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    WebSocketNetworkTransport$execute$slambdaClass_0 = $;
  }
  return WebSocketNetworkTransport$execute$slambdaClass_0;
}
function WebSocketNetworkTransport$execute$slambda_2($request) {
  var i = new (WebSocketNetworkTransport$execute$slambda_1())($request);
  var l = ($this$transformWhile, it, $completion) => i.q6d($this$transformWhile, it, $completion);
  l.$arity = 2;
  return l;
}
var WebSocketNetworkTransport$execute$$inlined$map$1Class;
function WebSocketNetworkTransport$execute$$inlined$map$1() {
  if (WebSocketNetworkTransport$execute$$inlined$map$1Class === VOID) {
    class $ {
      constructor($this, $request, $deferredJsonMerger, this$0) {
        this.t6d_1 = $this;
        this.u6d_1 = $request;
        this.v6d_1 = $deferredJsonMerger;
        this.w6d_1 = this$0;
      }
      *g1d(collector, $completion) {
        var tmp = WebSocketNetworkTransport$execute$o$collect$slambda_2(collector, this.u6d_1, this.v6d_1, this.w6d_1);
        yield* this.t6d_1.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      p1c(collector, $completion) {
        return this.g1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$map$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$map$1Class;
}
var WebSocketNetworkTransport$execute$$inlined$filterNot$1Class;
function WebSocketNetworkTransport$execute$$inlined$filterNot$1() {
  if (WebSocketNetworkTransport$execute$$inlined$filterNot$1Class === VOID) {
    class $ {
      constructor($this, $deferredJsonMerger) {
        this.x6d_1 = $this;
        this.y6d_1 = $deferredJsonMerger;
      }
      *g1d(collector, $completion) {
        var tmp = WebSocketNetworkTransport$execute$o$collect$slambda_4(collector, this.y6d_1);
        yield* this.x6d_1.p1c(new (sam$kotlinx_coroutines_flow_FlowCollector$0())(tmp), $completion);
        return Unit_instance;
      }
      p1c(collector, $completion) {
        return this.g1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$$inlined$filterNot$1Class = $;
  }
  return WebSocketNetworkTransport$execute$$inlined$filterNot$1Class;
}
var WebSocketNetworkTransport$execute$slambdaClass_1;
function WebSocketNetworkTransport$execute$slambda_3() {
  if (WebSocketNetworkTransport$execute$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $request) {
        this.z6d_1 = this$0;
        this.a6e_1 = $request;
      }
      *b6e($this$onCompletion, it, $completion) {
        yield* this.z6d_1.r6c_1.s1a(new (StopOperation())(this.a6e_1), $completion);
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector()) : false) ? p1 : THROW_CCE();
        return this.b6e(tmp, (p2 == null ? true : p2 instanceof Error) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    WebSocketNetworkTransport$execute$slambdaClass_1 = $;
  }
  return WebSocketNetworkTransport$execute$slambdaClass_1;
}
function WebSocketNetworkTransport$execute$slambda_4(this$0, $request) {
  var i = new (WebSocketNetworkTransport$execute$slambda_3())(this$0, $request);
  var l = ($this$onCompletion, it, $completion) => i.b6e($this$onCompletion, it, $completion);
  l.$arity = 2;
  return l;
}
var WebSocketNetworkTransportClass;
function WebSocketNetworkTransport() {
  if (WebSocketNetworkTransportClass === VOID) {
    class $ {
      constructor(serverUrl, headers, webSocketEngine, idleTimeoutMillis, protocolFactory, reopenWhen) {
        webSocketEngine = webSocketEngine === VOID ? new (DefaultWebSocketEngine())() : webSocketEngine;
        idleTimeoutMillis = idleTimeoutMillis === VOID ? 60000n : idleTimeoutMillis;
        protocolFactory = protocolFactory === VOID ? new (Factory())() : protocolFactory;
        this.l6c_1 = serverUrl;
        this.m6c_1 = headers;
        this.n6c_1 = webSocketEngine;
        this.o6c_1 = idleTimeoutMillis;
        this.p6c_1 = protocolFactory;
        this.q6c_1 = reopenWhen;
        this.r6c_1 = Channel(2147483647);
        this.s6c_1 = MutableSharedFlow(0, 2147483647, BufferOverflow_SUSPEND_getInstance());
        this.t6c_1 = asSharedFlow(this.s6c_1);
        this.u6c_1 = this.s6c_1.v1e();
        this.v6c_1 = Dispatchers_getInstance().x12_1.o12(1);
        this.w6c_1 = CoroutineScope_0(this.v6c_1);
        launch(this.w6c_1, VOID, VOID, WebSocketNetworkTransport$slambda_0(this));
        var tmp = this;
        tmp.x6c_1 = new (WebSocketNetworkTransport$listener$1())(this);
      }
      t66(request) {
        var deferredJsonMerger = new (DeferredJsonMerger())();
        // Inline function 'kotlinx.coroutines.flow.filter' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_0 = onSubscription(this.t6c_1, WebSocketNetworkTransport$execute$slambda_0(this, request));
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp = new (WebSocketNetworkTransport$execute$$inlined$filter$1())(this_0, request);
        // Inline function 'kotlinx.coroutines.flow.map' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_1 = transformWhile(tmp, WebSocketNetworkTransport$execute$slambda_2(request));
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        // Inline function 'kotlinx.coroutines.flow.filterNot' call
        // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
        var this_2 = new (WebSocketNetworkTransport$execute$$inlined$map$1())(this_1, request, deferredJsonMerger, this);
        // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
        var tmp_0 = new (WebSocketNetworkTransport$execute$$inlined$filterNot$1())(this_2, deferredJsonMerger);
        return onCompletion(tmp_0, WebSocketNetworkTransport$execute$slambda_4(this, request));
      }
      jz() {
        this.r6c_1.t1a(Dispose_instance);
      }
    }
    initMetadataForClass($, 'WebSocketNetworkTransport', VOID, VOID, VOID, [1]);
    WebSocketNetworkTransportClass = $;
  }
  return WebSocketNetworkTransportClass;
}
//region block: exports
export {
  Builder_0 as Builder3moivcm5iuump,
};
//endregion

//# sourceMappingURL=WebSocketNetworkTransport.mjs.map
